import { onMounted, ref } from 'vue';
import { fetchApplicationDetail } from '@/entities/application/api/fetchApplicationDetail';
import type { ApplicationDetail } from '@/entities/application/model/types';
import { useRoute } from 'vue-router';

/**
 * 申し込み詳細データ取得のカスタムフック
 * @returns 申し込み詳細データとエラーメッセージ、refetchメソッド
 */
export const useFetchApplicationDetail = () => {
    const route = useRoute();
    const detail = ref<ApplicationDetail>();
    const errorMessage = ref<string>();
    const isLoading = ref(true);

    const fetch = async () => {
        try {
            isLoading.value = true;
            errorMessage.value = undefined;
            detail.value = await fetchApplicationDetail(route.params.applicationId as string);
        } catch (error) {
            errorMessage.value = (error as Error).message;
        } finally {
            isLoading.value = false;
        }
    };

    onMounted(fetch);

    return {
        detail,
        errorMessage,
        isLoading,
        refetch: fetch,
    };
};
